import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

import accountapi from '@/shared/api/account';

export const accountStore = createStore({
    plugins: [createPersistedState({
        key: 'vuex-account'
    })],
    state: {
        accountConfiguration: null,

        authenticatedSession: null,
        userProfile: null,

    },
    getters: {
        accountConfiguration(state) {
            return state.accountConfiguration;
        },

        token(state) {
            if (state.authenticatedSession != null) {
                return state.authenticatedSession.access_token;
            }
            return null;
        },
        isAuthenticated(state) {
            return state.authenticatedSession != null;
        },
        userProfile(state) {
            return state.userProfile;
        },
        refreshToken(state) {
            if (state.authenticatedSession != null) {
                return state.authenticatedSession.refresh_token;
            }
            return null;
        }
    },
    actions: {

        register(context, payload) {
            return new Promise((resolve, reject) => {
                accountapi.register(payload,
                    t => {
                        resolve(t);
                    },
                    t => {
                        reject({ error: t });
                    });

            });
        },
        update(context, payload) {
            return new Promise((resolve) => {

                accountapi.update(payload,
                    t => {
                        context.commit('setUserProfile', t);
                        resolve(t);
                    });

            });
        },
        loadSession(context) {
            return new Promise((resolve) => {
                accountapi.getSession(t => {
                    context.commit('setUserProfile', t);
                    resolve(t);
                });
            });
        },
        login(context, payload) {
            return new Promise((resolve, reject) => {

                accountapi.login(payload.username,
                    payload.password,
                    t => {
           
                        context.commit('setAuthenticatedSession', t.data);
                        resolve(t.data);
                    },
                    t => {

             
                        reject({ error: t });
                    });
            });
        },
        refresh(context, token) {
  
            return new Promise((resolve, reject) => {
                accountapi.refreshToken(
                    token,
                    t => {
                        context.commit('setAuthenticatedSession', t.data);
              
                        resolve(t.data);
                    },
                    t => {
                        reject({ error: t });
                    });
            });

        },
        logout(context) {
            return new Promise((resolve) => {
                context.commit('setConfiguration', null);
                context.commit('setUserProfile', null);
                context.commit('setAuthenticatedSession', null);
                resolve();
            });
        },
        changePassword(context, payload) {
            return new Promise((resolve, reject) => {
                accountapi.changePassword(payload,
                    t => {
                        resolve(t);
                    },
                    f => {
                        reject(f);
                    });
            });
        },
        clearData(context) {
            context.commit('setConfiguration', null);
            context.commit('setUserProfile', null);
            context.commit('setAuthenticatedSession', null);
        },
        getConfiguration(context) {
            return new Promise((resolve) => {
                accountapi.getConfiguration(t => {
                    context.commit('setConfiguration', t);
                    resolve(t);
                });
            });
        },

    },
    mutations: {
        setConfiguration(state, payload) {
            state.accountConfiguration = payload;
        },

        setAuthenticatedSession(state, payload) {
            state.authenticatedSession = payload;
        },
        setUserProfile(state, payload) {
            state.userProfile = payload;
        }
    }

});
